<template>
	<div v-if="!loadingRevision">
    <div v-if="model.deleted" class="alert alert-danger">
      <p class=""> <b> ATTENZIONE</b> Questa revisione è una revisione eliminata. Le modifiche che apporti non saranno visibili</p>
    </div>
    <div class="row">
      <div class="col-12 col-md-8">
    		<h2 class="page-title">
    			<router-link :to="`/sites/${engine.site}/engines/${$route.params.engineId}`">
        			<i class="icon-minimal-left tim-icons" />
    			</router-link>
    			Revisione <span v-if="engine"> - {{engine.name}} ({{engine.registrationNumber}})  <span v-if="site"> - {{site.name}}</span></span>
    		</h2>
      </div>
      <div class="col-12 col-md-4 text-md-right">
        <router-link
          class="text-info small"
          v-if="user.is('backoffice') && model.phase =='final'"
          :to="buildConnectedRevisionUrl('initialRevision')"
          >
            <b>Vai alla revisione tecnica</b> <i class="icon-minimal-right tim-icons" />
        </router-link>
        <router-link
          class="text-info small"
          v-if="user.is('backoffice') && model.phase !== 'final' && model.finalRevision"
          :to="buildConnectedRevisionUrl('finalRevision')"
          >
            <b>Vai alla revisione amministrativa</b> <i class="icon-minimal-right tim-icons" />
        </router-link>
        <router-link
          class="text-info small"
          v-if="user.is('backoffice') && model.phase !== 'final' && !model.finalRevision"
          :to="`/engines/${$route.params.engineId}/revisions/${$route.params.id}/create-final`"
          >
            <b>Crea revisione amministrativa</b> <i class="icon-minimal-right tim-icons" />
        </router-link>
      </div>
    </div>

    <revision-form
      v-if="!loading"
      :is-saving="isSaving"
      :site="site"
      :model="model"
      :on-submit="updateRevisionSubmit"
      submit-message="Salva" />
    <loading v-else />
	</div>
	<loading  v-else />

</template>
<script>
import RevisionForm from '@/components/Revisions/RevisionForm.vue'

import { mapState, mapActions } from 'vuex'


export default{
  computed: {
    ...mapState({
      revisions: state => state.revisions.revisions.docs,
      site: state => state.sites.site,
      model: state => state.revisions.revision,
      // loadingRevision: state => state.revisions.loading,
      loading: state => state.engines.loading,
		  engine: state => state.engines.engine,
      user: state => state.account.user,
    })
  },
  beforeMount(){
    this.voidRevision()
  },
  async mounted() {
    const {engineId, id} = this.$route.params;
    await this.get({engineId, id})
    await this.getEngine({id: engineId})
    this.loadingRevision = false
    // this.loadingRevision = true
  },
  watch: {
    // model: function(newValue){
    //   if ( newValue ){
    //     // this.model.workers = this.model.workers.map(worker => worker._id)
    //   }
    // },
    engine: function(newValue) {
      if (newValue !== null){
        this.model.engine = newValue.id
        this.getSite(newValue.site)
      }
    },
    async $route(from,to) {
      const {engineId, id} = this.$route.params;
      await this.get({engineId, id})
      await this.getEngine({id: engineId})
      this.loadingRevision = false
    }
  },
  components: {
    RevisionForm
  },
  methods: {
    ...mapActions('engines', {
      getEngine: 'get'
    }),
    ...mapActions('sites', {
      getSite: 'get'
    }),
    ...mapActions('revisions', {
      get: 'get',
      update: 'update',
      voidRevision: 'voidCurrent'
    }),
    buildConnectedRevisionUrl(phase) {
      if ( typeof this.model[phase] === 'string')  {
        return `/engines/${this.$route.params.engineId}/revisions/${this.model[phase]}`
      }
        return `/engines/${this.$route.params.engineId}/revisions/${this.model[phase]._id}`

    },
    async updateRevisionSubmit() {
      this.isSaving = true
      delete this.model.technicalEmailSent
      delete this.model.technicalEmailSentDetails
    	await this.update(this.model)
      this.isSaving = false

    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
  data() {
    return {
      isSaving: false,
      loadingRevision: true
    }
  }
}	
</script>